export const SET_BENEFICIARY_GENDER ='SET_BENEFICIARY_GENDER';
export const SET_BENEFICIARY_REDG_OPTION ='SET_BENEFICIARY_REDG_OPTION';
export const SET_BENEFICIARY_AUTH_TYPE ='SET_BENEFICIARY_AUTH_TYPE';
export const SET_BENEFICIARY_MOBILE_NUMBER='SET_BENEFICIARY_MOBILE_NUMBER';
export const SET_TSNID='SET_TSNID';
export const SET_TXNID_FOR_ABHA_ADDRESS='SET_TXNID_FOR_ABHA_ADDRESS';
export const SET_ABHA_ADDRESS='SET_ABHA_ADDRESS';
export const SET_PRIMARY_NO_FOR_RCH='SET_PRIMARY_NO_FOR_RCH';
export const SET_BENF_ID='SET_BENF_ID'
export const SET_IMAGE_DATA='SET_IMAGE_DATA'
export const SET_IMAGE_EDITED='SET_IMAGE_EDITED'
export const SET_AADHAR='SET_AADHAR';
export const SET_BENEFICIARY_ALREADY_IN_RCH='SET_BENEFICIARY_ALREADY_IN_RCH';
export const SET_BENEFICIARIES_IN_RCH='SET_BENEFICIARIES_IN_RCH';
export const SET_BENEFICIARY_DATA='SET_BENEFICIARY_DATA'
export const SET_BENEFICIARY_ABHA='SET_BENEFICIARY_ABHA'
export const UPDATE_CHILD='UPDATE_CHILD'
export const SET_BENEFICIARY_DETAILS='SET_BENEFICIARY_DETAILS'
export const SET_SHOW_CLOSE_MODAL='SET_SHOW_CLOSE_MODAL'
export const SET_IS_BENEFICIARY_MODIFIED='SET_IS_BENEFICIARY_MODIFIED'
export const UPDATE_ANCSERVICE='UPDATE_ANCSERVICE'
export const SET_ANC_NUMBER='SET_ANC_NUMBER';
export const SET_ANC_VISIT_DATE='SET_ANC_VISIT_DATE'
export const SET_SHOW_PREGNANCY='SET_SHOW_PREGNANCY'
export const SET_SHOW_SERVICES='SET_SHOW_SERVICES'
export const SET_ANC_VISIT_NUMBER='SET_ANC_VISIT_NUMBER'
export const SET_FACILITY_DETAILS='SET_FACILITY_DETAILS'
export const SET_PREGNANCY_ID='SET_PREGNANCY_ID'
export const SET_LMP_DATE='SET_LMP_DATE'
export const SET_DIFF_IN_WEEKS='SET_DIFF_IN_WEEKS'
export const SET_IS_VIEW_BUTTON_CLICKED='SET_IS_VIEW_BUTTON_CLICKED'
export const UPDATE_PREG_HANDLER='UPDATE_PREG_HANDLER' 
export const SET_SHOW_PREGNANCY_ONGOING='SET_SHOW_PREGNANCY_ONGOING'
export const UPDATE_DELIVERY_DETAILS='UPDATE_DELIVERY_DETAILS' 
export const UPDATE_FAMILY_PLANNING_BACK_HANDLER='UPDATE_FAMILY_PLANNING_BACK_HANDLER' 
export const SET_FAMILY_PLANNING_DETAILS = 'SET_FAMILY_PLANNING_DETAILS'
export const SET_FAMILY_PLANNING_DETAILS_BY_TRANSACTION_ID = 'SET_FAMILY_PLANNING_DETAILS_BY_TRANSACTION_ID'
export const UPDATE_PNC = 'UPDATE_PNC'
export const SET_CONSENT_LANGUAGE='SET_CONSENT_LANGUAGE'
export const SET_IS_FIRST_PREGNANCY='SET_IS_FIRST_PREGNANCY'
export const SET_CHECK_IS_HRP ='SET_CHECK_IS_HRP'
export const SET_IS_HRP='SET_IS_HRP'
export const UPDATE_FACILITY_META_DATA = 'UPDATE_FACILITY_META_DATA'
export const SET_IS_PREGNANT='SET_IS_PREGNANT'
export const SET_PREGNANCY_HISTORY='SET_PREGNANCY_HISTORY'
export const SET_BENF_DEATH_DETAILS='SET_BENF_DEATH_DETAILS'
export const UPDATE_CHILD_DETAILS='UPDATE_CHILD_DETAILS'
export const UPDATE_FACILITY_SERVICE_DATA='UPDATE_FACILITY_SERVICE_DATA'
export const VERIFY_CHILD_FROM_GRID='VERIFY_CHILD_FROM_GRID'
export const UPDATE_CURRENT_HIV_TEST='UPDATE_CURRENT_HIV_TEST'
export const UPDATE_MOTHER_SYPHILIS_TEST = 'UPDATE_MOTHER_SYPHILIS_TEST';
export const SET_REFERRAL_MODULE = 'SET_REFERRAL_MODULE';
export const SET_LIFE_CALENDAR_PAGE_FOR_PREVIOUS_PREGNANCY = 'SET_LIFE_CALENDAR_PAGE_FOR_PREVIOUS_PREGNANCY';
export const SET_LIFE_CALENDAR_PAGE_MENU = 'SET_LIFE_CALENDAR_PAGE_MENU'
export const SET_BENEFICIARY_PREGNANCY_HISTORY = 'SET_BENEFICIARY_PREGNANCY_HISTORY'
export const SET_PREGNANCY_DETAILS = 'SET_PREGNANCY_DETAILS'
export const SET_HRP_STATUS = 'SET_HRP_STATUS'
export const SET_BENEFICIARY_IMAGE = 'SET_BENEFICIARY_IMAGE'
export const SET_CHILD_BENEF_LIST = 'SET_CHILD_BENEF_LIST'
export const SET_BENEFICIARY_OBSTETRIC_HISTORY = 'SET_BENEFICIARY_OBSTETRIC_HISTORY'

export interface setBeneficiaryGender {
    type:typeof SET_BENEFICIARY_GENDER;
    payload: string
};
 
export interface setBeneficiaryRedgeOption {
    type:typeof SET_BENEFICIARY_REDG_OPTION;
    payload: string
};
export interface setBeneficiaryAuthType {
    type:typeof SET_BENEFICIARY_AUTH_TYPE;
    payload: string
};
export interface setBeneficiaryMobileNumber {
    type:typeof SET_BENEFICIARY_MOBILE_NUMBER;
    payload: string
};
export interface setTsnID {
    type:typeof SET_TSNID;
    payload: string
};
export interface setTxnIdForAbhaAddress {
    type:typeof SET_TXNID_FOR_ABHA_ADDRESS;
    payload: string
};
export interface setAbhaAddress {
    type:typeof SET_ABHA_ADDRESS;
    payload: string
};
export interface setPrimaryNoForRCH {
    type:typeof SET_PRIMARY_NO_FOR_RCH;
    payload: string
};
export interface setAadhar {
    type:typeof SET_AADHAR;
    payload: string
};
export interface beneficiaryAlreadyInRCH {
    type:typeof SET_BENEFICIARY_ALREADY_IN_RCH;
    payload: string
};
export interface beneficiariesInRCH {
    type:typeof SET_BENEFICIARIES_IN_RCH;
    payload: string
};
 
export interface setBeneficiaryData {
    type:typeof SET_BENEFICIARY_DATA;
    payload: string
};

export interface setBeneficiaryAbha {
    type:typeof SET_BENEFICIARY_ABHA
    payload: string
};

export interface updateChildAction{
    type: typeof UPDATE_CHILD;
    payload:{field:string;value:string};
}
 

export interface showCloseModal {
    type:typeof SET_SHOW_CLOSE_MODAL
    payload: string
};
export interface isBeneficiaryModified {
    type:typeof SET_IS_BENEFICIARY_MODIFIED 
    payload: string
};

export interface setBeneficiaryDetails {
    type:typeof SET_BENEFICIARY_DETAILS 
    payload: string
}
export interface setBenfId {
    type:typeof SET_BENF_ID
    payload: string
};
export interface setCheckIsHRP {
    type:typeof SET_CHECK_IS_HRP
    payload: boolean
};
 
export interface isImageEdited {
    type:typeof SET_IMAGE_EDITED
    payload: string
};
export interface imageData {
    type:typeof SET_IMAGE_DATA
    payload: string
};
export interface updateAncServiceAction{
    type: typeof UPDATE_ANCSERVICE;
    payload:{field:string;value:string};
}
export interface setANCNumber{
    type: typeof SET_ANC_NUMBER;
    payload:number
}

export interface setANCVisitDate{
    type: typeof SET_ANC_VISIT_DATE;
    payload:string
}
export interface setFacilityDetails{
    type: typeof SET_FACILITY_DETAILS;
    payload:number
}

export interface setIsFirstPregnancy{
    type: typeof SET_IS_FIRST_PREGNANCY;
    payload:boolean
}

export interface setPregnancyId{
    type: typeof SET_PREGNANCY_ID;
    payload:string
}
export interface setPregnancyHistory{
    type: typeof SET_PREGNANCY_HISTORY;
    payload:any
}
export interface setShowPregnancy{
    type: typeof SET_SHOW_PREGNANCY;
    payload:boolean
} 

export interface setPregnancyOngoing{
    type: typeof SET_SHOW_PREGNANCY_ONGOING;
    payload:boolean
}
export interface setShowServices{
    type: typeof SET_SHOW_SERVICES;
    payload:boolean
}
 
export interface setLmpDate{
    type: typeof SET_LMP_DATE;
    payload:string
}

export interface setdiffInWeeks{
    type: typeof SET_DIFF_IN_WEEKS;
    payload:number
}
export interface setIsViewButtonClicked{
    type: typeof SET_IS_VIEW_BUTTON_CLICKED;
    payload:boolean
}


export interface setAncPregBackHandler{
    type: typeof UPDATE_PREG_HANDLER;
    payload:boolean
}

export interface updateDeliveryDetails{
    type: typeof UPDATE_DELIVERY_DETAILS;
    payload:{field:string;value:string};
}

export interface updateChildVerifyFromGrid{
    type: typeof VERIFY_CHILD_FROM_GRID;
    payload:boolean;
}
export interface updatePNC{
    type: typeof UPDATE_PNC;
    payload:{field:string;value:string};
}
export interface setFamilyPlanningBackHandler{
    type: typeof UPDATE_FAMILY_PLANNING_BACK_HANDLER;
    payload:boolean
}

export interface setFamilyPlanningDetails{
    type:typeof SET_FAMILY_PLANNING_DETAILS 
    payload: string
}

export interface setFamilyPlanningDetailsByTransactionId{
    type:typeof SET_FAMILY_PLANNING_DETAILS_BY_TRANSACTION_ID 
    payload: string
}


export interface setIsHRP{
    type:typeof SET_IS_HRP 
    payload: boolean
}
export interface setConsentLanguage{
    type: typeof SET_CONSENT_LANGUAGE;
    payload:any
}

export interface setFacilityMetaData{
    type: typeof UPDATE_FACILITY_META_DATA;
    payload:any
}

export interface setFacilityServiceData{
    type: typeof UPDATE_FACILITY_SERVICE_DATA;
    payload:any
}

export interface setIsPregnant{
    type: typeof SET_IS_PREGNANT;
    payload:any
} 

export interface setBenefDeathDetails{
    type: typeof SET_BENF_DEATH_DETAILS;
    payload:any
}
export interface updateChildDetails{
    type: typeof UPDATE_CHILD_DETAILS;
    payload:any
}

export interface updateCurrentHIVTest {
    type: typeof UPDATE_CURRENT_HIV_TEST,
    payload: string,
}

export interface setRefferalModuleAction{
    type: typeof SET_REFERRAL_MODULE;
    payload:{field:string;value:string};
}

export interface setLifeCalendarPageMenu {
    type:typeof SET_LIFE_CALENDAR_PAGE_MENU;
    payload: any
};
export interface setBeneficiaryPregnancyHistory {
    type:typeof SET_BENEFICIARY_PREGNANCY_HISTORY;
    payload: any
};
export interface setPregnancyDetails {
    type:typeof SET_PREGNANCY_DETAILS;
    payload: any
};
export interface setHrpStatus {
    type:typeof SET_HRP_STATUS;
    payload: any
};
export interface setBeneficiaryImage {
    type:typeof SET_BENEFICIARY_IMAGE;
    payload: any
};
export interface setChildBenefList {
    type:typeof SET_CHILD_BENEF_LIST;
    payload: any
};

export interface setLifeCalendarPagePreviousPragnancy {
    type:typeof SET_LIFE_CALENDAR_PAGE_FOR_PREVIOUS_PREGNANCY;
    payload: any
};
export interface setBeneficiaryObstetricHistory {
    type:typeof SET_BENEFICIARY_OBSTETRIC_HISTORY;
    payload: any
};

export type beneficiaryActionType = setBeneficiaryGender|setBenefDeathDetails |updateChildVerifyFromGrid|setFacilityServiceData|setIsPregnant | setCheckIsHRP |setIsFirstPregnancy|setIsHRP|setShowServices | setPregnancyOngoing | setShowPregnancy |setIsViewButtonClicked|setANCVisitDate|setLmpDate|setdiffInWeeks |setBeneficiaryRedgeOption | setBeneficiaryAuthType | setBeneficiaryMobileNumber | setTsnID | setAadhar | setBeneficiaryData | setBeneficiaryAbha | showCloseModal | isBeneficiaryModified | updateChildAction | setBeneficiaryDetails |setBenfId |isImageEdited|imageData | updateAncServiceAction |setANCNumber |setFacilityDetails | setPregnancyId | setPregnancyHistory | setAncPregBackHandler | updateDeliveryDetails | setFamilyPlanningBackHandler | setFamilyPlanningDetails | setFamilyPlanningDetailsByTransactionId | setConsentLanguage| updatePNC| setFacilityMetaData| updateChildDetails | beneficiaryAlreadyInRCH | beneficiariesInRCH |setTxnIdForAbhaAddress|setAbhaAddress|setPrimaryNoForRCH|setRefferalModuleAction | setLifeCalendarPageMenu | setBeneficiaryPregnancyHistory | setPregnancyDetails | setHrpStatus | setBeneficiaryImage | setChildBenefList | setLifeCalendarPagePreviousPragnancy | setBeneficiaryObstetricHistory;
